import { render, staticRenderFns } from "./CampaignEdit.vue?vue&type=template&id=2dc1c81f&scoped=true"
import script from "./CampaignEdit.vue?vue&type=script&lang=js"
export * from "./CampaignEdit.vue?vue&type=script&lang=js"
import style0 from "./CampaignEdit.vue?vue&type=style&index=0&id=2dc1c81f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc1c81f",
  null
  
)

export default component.exports